export const formatNumberWithIntl = (number) => {
	return new Intl.NumberFormat('fr-FR').format(number)
}
